import React, { useState } from 'react';
import service from '../../../services/accountingReports.service';
import { REPORT_BUTTON } from './reportUtils';

export default function XlsInvoice() {
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState('');
  const download = async (event: React.FormEvent) => {
    event.preventDefault();
    const number = invoiceNumber.trim().toUpperCase();
    setError(null); setStatus('');
    if (!number.replace(/[^a-z0-9]/gi, '')) { setError('Enter an invoice number.'); return; }
    setInvoiceNumber(number); setLoading(true);
    try {
      const filename = await service.downloadXlsInvoice(number);
      setStatus(filename ? `Downloaded ${filename}` : 'Download cancelled.');
    } catch (e) {
      setError((e as { response?: { status?: number } })?.response?.status === 404
        ? `Invoice ${number} not found.` : 'Unable to download the invoice. Please try again.');
    } finally { setLoading(false); }
  };
  return <div className="p-4 space-y-4 text-label">
    <h1 className="text-xl font-semibold">XLS Invoice</h1>
    <form onSubmit={download} className="max-w-2xl rounded-lg border border-theme-border-primary bg-theme-bg-primary p-4 space-y-4">
      <div className="max-w-sm space-y-1">
        <label htmlFor="xls-invoice-number" className="block text-sm font-medium">Invoice #</label>
        <input id="xls-invoice-number" type="text" autoComplete="off" value={invoiceNumber} disabled={loading}
          onChange={e => setInvoiceNumber(e.target.value)} onBlur={() => setInvoiceNumber(value => value.toUpperCase())}
          className="w-full rounded border border-theme-border-secondary bg-theme-bg-primary px-3 py-2 text-sm" />
      </div>
      <p className="text-sm text-muted">Produces the customer-facing invoice workbook, the same file V1's XLS Invoice report produced.</p>
      <button type="submit" disabled={loading} className={REPORT_BUTTON}>{loading ? 'Downloading…' : 'Download'}</button>
      {error && <p role="alert" className="text-sm text-red-600 dark:text-red-400">{error}</p>}
      <p role="status" className="text-sm">{loading ? 'Preparing invoice workbook…' : status}</p>
    </form>
  </div>;
}
